export interface IFrameInitStyles {
  zIndex: string;
  colorScheme: string;
  display: string;
  width: string;
  filter?: string;
  transition?: string;
}
